var styleDataHash = '484031f5';  
export const injectCss = (() => {
  var css = `._6Q2em,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.OriZ8{border-color:rgba(var(--ricos-text-color-tuple,33,33,33),.4);border-style:solid;border-width:1px;box-shadow:0 0 10px 0 rgba(0,0,0,.06);position:fixed;z-index:11}@supports (color:rgb(from #000 r g b/0.1)){.OriZ8{border-color:rgb(from var(--ricos-text-color,#212121) r g b/.4)}}.X2G7i{background-color:#fff;max-height:339px;max-width:360px}.X2G7i,.ab7PX{display:flex;flex-direction:column}.ab7PX{gap:4px;padding:16px}.A3PQk{color:var(--ricos-text-color-low,#646464);font-size:14px;line-height:20px}.uRDSc{font-size:16px;line-height:24px}.WoAgD,.uRDSc{color:var(--ricos-text-color,#212121);display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical}.WoAgD{font-size:14px;line-height:20px}.UFapL{height:100%;width:100%}.f6Iqq{height:190px;width:100%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "_6Q2em",
  "container": "OriZ8",
  "viewerContainer": "X2G7i",
  "texts": "ab7PX",
  "url": "A3PQk",
  "title": "uRDSc",
  "description": "WoAgD",
  "Image": "UFapL",
  "ImageWrapper": "f6Iqq"
};